module.exports = __webpack_public_path__ + "static/img/wepvideo.304cdf4e.jpg";